import { Card, CardContent, CardHeader, Text, Grid, View } from 'primase';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './styles';

// Constants
import { PAYMENT_METHODS } from '../../constants/order';
import {
  TBillingWizardStepData,
  TPatientsWizardStepData,
} from '../../features/order/types';

interface IOrderDetailsProps {
  patients: TPatientsWizardStepData;
  billing: TBillingWizardStepData;
  // eslint-disable-next-line @typescript-eslint/ban-types
  mainContainerStyle?: object;
}

const OrderDetails = ({
  billing,
  patients,
  mainContainerStyle,
}: IOrderDetailsProps) => {
  const { t } = useTranslation();

  const paymentMethod =
    billing?.preferredPaymentMethod === 'INSURANCE' ? 'insurance' : 'self-pay';

  const getCorrectPrice = (price: number) => {
    if (billing?.preferredPaymentMethod === PAYMENT_METHODS.CARD) {
      return <Text css={styles.price}>${price.toFixed(2)}</Text>;
    }

    return (
      <div style={styles.insurancePriceContainer}>
        <Text css={styles.insurancePrice}>{t('orders.billedToInsurance')}</Text>
      </div>
    );
  };

  const getSumPrice = () => {
    const price1 = !Number.isNaN(+billing?.estimatedPrice?.[0]?.price)
      ? +billing?.estimatedPrice?.[0]?.price
      : 0;
    const price2 = !Number.isNaN(+billing?.estimatedPrice?.[1]?.price)
      ? +billing?.estimatedPrice?.[1]?.price
      : 0;
    const orderSum = price1 + price2;

    return paymentMethod === 'insurance' ? (
      <Text css={styles.insuranceSum}>{t('orders.insuranceAfterResults')}</Text>
    ) : (
      <Text css={styles.totalSumMainText}>${orderSum.toFixed(2)}</Text>
    );
  };

  return (
    <View css={mainContainerStyle}>
      <Card>
        <CardHeader
          headerStyle={styles.unborderedBottom}
          css={styles.cardHeader}
        >
          <Text style={styles.headerTitle}>{t('orders.orderDetails')}</Text>
        </CardHeader>
        <CardContent css={styles.cardContent}>
          {billing?.estimatedPrice?.[0] && (
            <Grid container>
              <Grid item md={8} css={styles.orderContainer}>
                <Text>
                  {billing.estimatedPrice[0].name} {t('orders.for')}{' '}
                  {patients?.patient.firstName} ({paymentMethod})
                </Text>
              </Grid>
              <Grid
                item
                css={styles.priceContainer}
                md={4}
                data-testid="correct-price"
              >
                {getCorrectPrice(Number(billing.estimatedPrice[0].price))}
              </Grid>
            </Grid>
          )}
          {billing?.estimatedPrice?.[1] && (
            <Grid container>
              <Grid item md={8} css={styles.orderContainer}>
                <Text>
                  {billing.estimatedPrice[1].name} {t('orders.for')}{' '}
                  {patients?.partner?.firstName} ({paymentMethod})
                </Text>
              </Grid>
              <Grid item css={styles.priceContainer} md={4}>
                <Text>
                  {getCorrectPrice(Number(billing.estimatedPrice[1].price))}
                </Text>
              </Grid>
            </Grid>
          )}
          <div style={styles.borderBottom} />

          <div style={styles.bottomContainer}>
            <div style={styles.totalSumContainer}>
              <Text css={styles.totalSumMainText}>Total</Text>
              {getSumPrice()}
            </div>
            {billing?.preferredPaymentMethod === PAYMENT_METHODS.CARD ? (
              <Text css={styles.billedIfAuthorizedLabel}>
                {t('orders.billedIfAuthorized')}
              </Text>
            ) : (
              <Text css={styles.billedIfAuthorizedLabel} />
            )}
          </div>
        </CardContent>
      </Card>
    </View>
  );
};

OrderDetails.defaultProps = {
  mainContainerStyle: {},
};

export default OrderDetails;
